var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVisual(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 40,
    viewBox: "0 0 41 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.5005 14.812C17.6255 14.812 15.313 17.1245 15.313 19.9995C15.313 22.8745 17.6255 25.187 20.5005 25.187C23.3755 25.187 25.688 22.8745 25.688 19.9995C25.688 17.1245 23.3755 14.812 20.5005 14.812ZM20.5005 22.3745C19.188 22.3745 18.1255 21.312 18.1255 19.9995C18.1255 18.687 19.188 17.6245 20.5005 17.6245C21.813 17.6245 22.8755 18.687 22.8755 19.9995C22.8755 21.312 21.813 22.3745 20.5005 22.3745Z",
    fill: "#111928"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M38.75 17.8118C35.1875 12.4993 30.25 7.12427 20.5 7.12427C10.75 7.12427 5.8125 12.4993 2.25 17.8118C1.375 19.1243 1.375 20.8743 2.25 22.1868C5.8125 27.4368 10.75 32.8743 20.5 32.8743C30.25 32.8743 35.1875 27.4368 38.75 22.1868C39.625 20.8118 39.625 19.1243 38.75 17.8118ZM36.4375 20.6243C31.875 27.3118 27.3125 30.0618 20.5 30.0618C13.6875 30.0618 9.125 27.3118 4.5625 20.6243C4.3125 20.2493 4.3125 19.7493 4.5625 19.3743C9.125 12.6868 13.6875 9.93677 20.5 9.93677C27.3125 9.93677 31.875 12.6868 36.4375 19.3743C36.625 19.7493 36.625 20.2493 36.4375 20.6243Z",
    fill: "#111928"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisual);
export default __webpack_public_path__ + "static/media/visual.4165662b968af8d98deca131b72eec99.svg";
export { ForwardRef as ReactComponent };